import { useRequirementCoverage } from '../../hooks/useDashboard';
import Spinner from '../ui/Spinner';

interface Props {
  projectId: string;
}

export default function RequirementCoverageWidget({ projectId }: Props) {
  const { data, isLoading } = useRequirementCoverage(projectId);

  if (isLoading) {
    return <div className="flex items-center justify-center h-full"><Spinner className="size-6" /></div>;
  }

  if (!data) {
    return (
      <div className="h-full flex flex-col">
        <h3 className="text-sm font-semibold text-gray-700 mb-2">요구사항 커버리지</h3>
        <div className="flex-1 flex items-center justify-center text-sm text-gray-400">데이터 없음</div>
      </div>
    );
  }

  return (
    <div className="h-full flex flex-col">
      <h3 className="text-sm font-semibold text-gray-700 mb-4">요구사항 커버리지</h3>
      <div className="flex-1 flex flex-col justify-center gap-5">
        <GaugeItem
          label="요구사항 → 기능명세"
          rate={data.requirements.coverageRate}
          detail={`${data.requirements.withSpec} / ${data.requirements.total}`}
          color="#3B82F6"
        />
        <GaugeItem
          label="기능명세 → 테스트케이스"
          rate={data.specifications.coverageRate}
          detail={`${data.specifications.withTestCase} / ${data.specifications.total}`}
          color="#10B981"
        />
      </div>
    </div>
  );
}

function GaugeItem({
  label,
  rate,
  detail,
  color,
}: {
  label: string;
  rate: number;
  detail: string;
  color: string;
}) {
  return (
    <div>
      <div className="flex items-center justify-between mb-1">
        <span className="text-sm text-gray-600">{label}</span>
        <span className="text-sm font-medium text-gray-900">{rate}%</span>
      </div>
      <div className="w-full bg-gray-200 rounded-full h-3 overflow-hidden">
        <div
          className="h-full rounded-full transition-all duration-500"
          style={{ width: `${rate}%`, backgroundColor: color }}
        />
      </div>
      <div className="text-[11px] text-gray-500 mt-0.5 text-right">{detail}</div>
    </div>
  );
}
